import { Skeleton } from "@/components/ui/skeleton";

const HeroSkeleton = () => {
  return (
    <section className="relative h-[100dvh] lg:h-[90vh] w-full overflow-hidden bg-dark">
      {/* Background shimmer */}
      <div className="absolute inset-0 bg-gradient-to-br from-muted/20 to-background animate-pulse" />
      
      {/* Content skeleton */}
      <div className="hero-content z-20">
        <div className="container mx-auto px-6 md:px-12">
          <div className="max-w-2xl">
            {/* Label */}
            <Skeleton className="h-4 w-32 mb-4" />
            
            {/* Title */}
            <div className="space-y-3 mb-8">
              <Skeleton className="h-12 md:h-16 w-full" />
              <Skeleton className="h-12 md:h-16 w-4/5" />
            </div>
            
            {/* Button */}
            <Skeleton className="h-12 w-40" />
          </div>
        </div>
      </div>
      
      {/* Indicators skeleton */}
      <div className="absolute bottom-8 left-6 md:left-12 flex gap-3 z-30">
        <Skeleton className="w-12 h-[2px]" />
        <Skeleton className="w-12 h-[2px]" />
        <Skeleton className="w-12 h-[2px]" />
      </div>
    </section>
  );
};

export default HeroSkeleton;
